<template lang="pug">
  .card(:class="is_loading?'loading':''")
    .card-body
      .d-flex
        per_page.text-muted(v-model="per_page" @input="refreshTable")
        table_filter.ml-auto.text-muted(v-model="searchParam" :items="['name', 'status']" @input="refreshTable")
        search.ml-3.text-muted(v-model="query" @search="refreshTable")

    .table-responsive
      vuetable.mb-0.card-table(
        ref="vuetable"
        :api-url="url" 
        :css="css"
        :fields="fields" 
        :per-page="per_page"
        data-path="data.data" 
        pagination-path="data" 
        :query-params="{ sort: 'sort', page: 'page', perPage: 'perPage' }"
        :append-params="{ searchParam: searchParam, query: query }"
        :http-options="{headers:{'Authorization': 'Bearer '+token}}"
        @vuetable:pagination-data="onPaginationData"
        @vuetable:loading="is_loading=true"
        @vuetable:loaded="is_loading=false"
      )
        template(slot="actions" slot-scope="props")
          custom_actions(:actions="actions" @action="$emit($event, props.rowData)")

    .card-footer.d-flex.align-items-center
      vuetable-pagination-info(ref="paginationInfo" :css="css.pagination")
      vuetable-pagination(ref="pagination" :css="css.pagination" @vuetable-pagination:change-page="onChangePage")

</template>

<script>
import BootstrapStyle from './bootstrap-css.js'
import per_page from '@/components/perPage'
import search from '@/components/search'
import filter from '@/components/filter'
import custom_actions from './customActions'
export default {
  props: ['url', 'fields', 'token', 'actions'],
  components: {
    per_page,
    search,
    table_filter: filter,
    custom_actions
  },
  data(){
    return {
      css: BootstrapStyle,
      per_page: 10,
      searchParam: 'name',
      query: '',
      is_loading: false,
    }
  },
  methods: {
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    async refreshTable(){
      await this.$nextTick();
      this.$refs.vuetable.refresh();
    }
  }
}
</script>